import { NgModule } from '@angular/core';
import { AUTH_ROUTING } from './routes';
import { AuthPage } from './pages/auth.page';
import { AuthSilentPage } from './pages/auth-silent.page';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule, AUTH_ROUTING],
    declarations: [AuthPage, AuthSilentPage],
})
export class NacoViewModule {}
